import { useSelection } from '@/app/SelectionContext';
import { Dropdown } from './Dropdown';
import { Badge } from './Badge';
import { periodLabel } from '@/utils/format';

export function PeriodSelector() {
  const { periods, periodId, setPeriodId, selectedPeriod, loading } = useSelection();

  if (!loading && periods.length === 0) {
    return <Badge tone="neutral">Периодов нет</Badge>;
  }

  const options = periods.map((period) => ({
    value: period.id,
    label: periodLabel(period.year, period.month),
    hint: period.status === 'CLOSED' ? 'Закрыт' : undefined,
  }));

  return (
    <Dropdown
      icon="calendar"
      label={
        loading
          ? 'Загрузка…'
          : selectedPeriod
            ? periodLabel(selectedPeriod.year, selectedPeriod.month)
            : 'Период'
      }
      value={periodId}
      options={options}
      onSelect={setPeriodId}
      disabled={loading}
    />
  );
}

/** Freshness matters: the owner must never mistake a draft month for a closed one. */
export function PeriodStatusBadge() {
  const { selectedPeriod } = useSelection();
  if (!selectedPeriod) return null;
  return selectedPeriod.status === 'CLOSED' ? (
    <Badge tone="positive">● Закрыт</Badge>
  ) : (
    <Badge tone="warning">● Черновик</Badge>
  );
}
